import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Flex } from '../../components/abstract';
import { Layout } from '../../components';
import AppConstants from '../../constants/appConstants';
import { useHistory } from 'react-router-dom';

const Container = styled(Flex)`
  position: relative;
`;

export const FinCredit = () => {
  const [height, setHeight] = useState('100%');
  const history = useHistory();

  useEffect(() => {
    const listener = event => {
      if (event.data?.type === 'route') {
        if (event.data?.data?.route) {
          history.push(event.data?.data?.route);
        }
      }
    };

    window.addEventListener('message', listener);

    return () => window.removeEventListener('message', listener);
  }, []);

  return (
    <Layout bg="#f4f8f9">
      <Container
        className="container"
        mx="auto"
        flexDirection="column"
        width="100%"
        height={height}
      >
        <iframe
          src={AppConstants.FINCREDIT_URL}
          width="100%"
          height="100%"
          onLoad={() => setHeight('1300px')}
        />
      </Container>
    </Layout>
  );
};
